import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import Home from '../components/home'
import MerchantAddOrEdit from '../components/merchant/add'
import Employee from '../components/employee/employee'
import Customer from '../components/customer/customer'
import Group from '../components/customerGroup/group'
import Sku from '../components/sku/sku'
import SkuAccountRecord from '../components/order/skuAccountRecord'
import OrderRecord from '../components/order/orderRecord'
import Permission from '../components/employee/permission'
import DataImport from '../components/data/dataImport'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '登录'
      },
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      meta: {
        title: '首页'
      },
      component: Home,
      children: [
        {
          path: '/employee/list',
          name: 'Employee',
          meta: {
            title: '员工列表'
          },
          component: Employee
        },
        {
          path: '/permission/list',
          name: 'Permission',
          meta: {
            title: '权限分组'
          },
          component: Permission
        },
        {
          path: '/customer/list',
          name: 'Customer',
          meta: {
            title: '顾客列表'
          },
          component: Customer
        },
        {
          path: '/customer/group',
          name: 'CustomerGroup',
          meta: {
            title: '顾客分组'
          },
          component: Group
        },
        {
          path: '/sku/list',
          name: 'sku',
          meta: {
            title: '商品-服务'
          },
          component: Sku
        },
        {
          path: '/recharge/record',
          name: 'recharge',
          meta: {
            title: '充值'
          },
          component: SkuAccountRecord
        },
        {
          path: '/order/list',
          name: 'order',
          meta: {
            title: '订单'
          },
          component: OrderRecord
        },
        {
          path: '/data/import',
          name: 'dataImport',
          meta: {
            title: '导入数据'
          },
          component: DataImport
        }
      ]
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component: MerchantAddOrEdit
    },
    {path: '/', redirect: '/home'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js